//TOPページよくある質問アコーディオンパネル(クラス付与クラス削除)
jQuery('.title').on('click', function() {
  jQuery('.box').slideUp(500);
    
  var findElm = jQuery(this).next(".box");
    
  if(jQuery(this).hasClass('close')){
    jQuery(this).removeClass('close');    
  }else{
    jQuery('.close').removeClass('close'); 
    jQuery(this).addClass('close');
    jQuery(findElm).slideDown(500);
  }
});

jQuery(window).on('load', function(){
  jQuery('.accordion-area li:first-of-type section').addClass("open"); 
  jQuery(".open").each(function(index, element){ 
    var Title =jQuery(element).children('.title');
    jQuery(Title).addClass('close'); 
    var Box =jQuery(element).children('.box');
    jQuery(Box).slideDown(500);
  });
});


jQuery('.top-lineup_content-slider').slick({
  centerMode: true,
  centerPadding: '60px',
  slidesToShow: 3,
  autoplay: true,
    dots: true,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        arrows: false,
        centerMode: true,
        centerPadding: '40px',
        slidesToShow: 3
      }
    },
    {
      breakpoint: 480,
      settings: {
        arrows: false,
        centerMode: true,
        centerPadding: '40px',
        slidesToShow: 1
      }
    }
  ]
});


// 購入ボタンをクッリクした際、強制的にカートページへ飛ぶ様にする
document.addEventListener('DOMContentLoaded', function () {
  const buyNowButton = document.querySelector('.shopify-payment-button__button');
  if (buyNowButton) {
    buyNowButton.addEventListener('click', function (e) {
      e.preventDefault();
      window.location.href = '/cart';
    });
  }
});


// モバイルメニュー開閉
document.addEventListener("DOMContentLoaded", function () {
  const toggleBtn = document.getElementById("mobile-menu-toggle");
  const menuList = document.querySelector(".nanacanele_header_list");
  const html = document.documentElement;
  const body = document.body;

  toggleBtn.addEventListener("click", function () {
    const isOpen = html.classList.contains("menu-open");

    if (isOpen) {
      // close
      html.classList.remove("menu-open", "menu-opened");
      body.classList.remove("menu-open");
      menuList.classList.remove("active");
    } else {
      // open
      html.classList.add("menu-open", "menu-opened");
      body.classList.add("menu-open");
      menuList.classList.add("active");
    }
  });

  // 背景クリックで閉じる
  const overlay = document.querySelector(".mobile-menu-overlay");
  overlay.addEventListener("click", function () {
    html.classList.remove("menu-open", "menu-opened");
    body.classList.remove("menu-open");
    menuList.classList.remove("active");
  });
});


// こだわりページのスラッグを指定して特定のクラスをつける
if (window.location.pathname === "/pages/commitment") {
  document.body.classList.add("commitment");
}



//スクロール時下から上に浮き上がる
function topWasabizuke(){

  jQuery('.fadeUpTrigger').each(function(){
    var elemPos = jQuery(this).offset().top-50;
    var scroll = jQuery(window).scrollTop();
    var windowHeight = jQuery(window).height();
    if (scroll >= elemPos - windowHeight){
    jQuery(this).addClass('fadeUp');
    }else{
    jQuery(this).removeClass('fadeUp');
    }
    });
}

jQuery(window).scroll(function (){
    topWasabizuke();
  });
